module.exports = __webpack_public_path__ + "img/exam_fail@2x.f8a1cc16.png";